import React from "react"
import "./projects.scss"
import AOS from "aos"
import "aos/dist/aos.css"
import Work from "../Work/Work"

AOS.init()

function Projects() {
  return (
    <div className="Projects" id="Projects">
      <div className="heading">
        <h1>PROJECTS</h1>
      </div>
      <div
        className="row-1"
        data-aos="fade-up"
        data-aos-offset="200"
        data-aos-delay="50"
        data-aos-duration="1000"
        data-aos-easing="ease"
        data-aos-mirror="false"
        data-aos-once="true"
      >
        <Work
          heading={"YouTube Clone "}
          para={
            "This is a Project of Youtube Clone all the data is being fetched from a Rest API and rendered into UI, and there is a sidebar where all the video has been categorized. Users can search and watch any kind of video and collect youtube channel info as well."
          }
          language={"ReactJs"}
          github_url={"https://github.com/Sharma572/youtube-clone-api"}
          site_url={"https://youtube-clone-api.vercel.app/"}
          color="#e4cb58"
        />
        <Work
          heading={"Linkdin Clone"}
          para={
            "This is a Linkedin clone where users may sign up for new accounts or login, and all credentials are validated using Firebase auth. The user may create a post, and all post data is kept in the firestore. A logout function is also offered."
          }
          language={"React Js , Firebase,FireStore"}
          github_url={"https://github.com/Sharma572/linkdin-clone"}
          site_url={"http://linkdin-clone-seven.vercel.app/"}
          color="#02f547"
        />
        <Work
          heading={"Tv Maze App "}
          para={
            "This Project helps to check the review of  Shows and as well as users can get info about actors and shows' names also."
          }
          language={"ReactJs"}
          github_url={"https://github.com/Sharma572/Tv-Maze-with-API"}
          site_url={"https://tv-maze-with-api.vercel.app/"}
          color="#e4cb58"
        />
      </div>
      <div
        className="row-2"
        data-aos="fade-up"
        data-aos-offset="200"
        data-aos-delay="50"
        data-aos-duration="1000"
        data-aos-easing="ease"
        data-aos-mirror="false"
        data-aos-once="true"
      >
        <Work
          heading={"CRUD operation"}
          para={
            "This is a project in which where users can perform  CRUD (create, read, update, and delete) operations and use Rest API."
          }
          language={"React.js"}
          github_url={"https://github.com/Sharma572/Full_CURD_Operation"}
          site_url={"https://curd-operation-22.netlify.app/"}
          color="#e4cb58"
        />
        <Work
          heading={"University Website"}
          para={
            "In this project basically,  the DRY principle of coding has been implemented to prevent repeated code from HTML web components which basically it allowing the set of web platform APIs that allow you to create new custom, reusable code. "
          }
          language={"HTML, Tailwindcss"}
          github_url={
            "https://github.com/Sharma572/HTML-CSS-Project---HTML-CSS-Mini-Project---vlhva4xirtk7.git"
          }
          site_url={"https://eduford-clone-2022.netlify.app/"}
          color="#58d8e4"
        />
        <Work
          heading={"Todo App"}
          para={
            "This Todo App is used to maintain our day-to-day tasks or list everything that user's tasks have to do."
          }
          language={"ReactJs,Bootstrap"}
          github_url={" https://github.com/Sharma572/todo"}
          site_url={"https://todo-with-react-2022.netlify.app/"}
          color="#58d8e4"
        />
      </div>
      <div
        className="row-2"
        data-aos="fade-up"
        data-aos-offset="200"
        data-aos-delay="50"
        data-aos-duration="1000"
        data-aos-easing="ease"
        data-aos-mirror="false"
        data-aos-once="true"
      >
        {" "}
        <Work
          heading={"The Avengers Website"}
          para={
            "This is the Parallax scrolling effect it is a special scrolling technique used in web design. where background images throughout a web page move slower than foreground images, creating an illusion of depth on a two-dimensional site."
          }
          language={"Html, CSS ,JS"}
          github_url={"https://github.com/Sharma572/Parallax-Effect-Website"}
          site_url={" https://friendly-jelly-8c2c98.netlify.app/"}
          color="#02f547"
        />
        <Work
          heading={"Random User Generator "}
          para={
            "In this project,  an API of the random username API will be used to get information about users on this website. These values are retrieved from the API. "
          }
          language={"HTML, CSS, JS"}
          github_url={"https://github.com/Sharma572/Random-user-Api"}
          site_url={"https://coruscating-quokka-ba3d27.netlify.app/"}
          color="#58d8e4"
        />
      </div>
    </div>
  );
}

export default Projects
